import { Component, OnInit, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, NgZone, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { v_DispatchNoteBus } from '../../shared/models/v_DispatchNoteBus';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditFormLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-formlines.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DispatchNoteBus } from '@app/cp/shared/models/DispatchNoteBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { DQOIReferenceData } from '../../shared/models/DQOIReferenceData';
import * as _ from 'lodash';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subscription, Subject, fromEvent } from 'rxjs';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DateFunctions } from '../../shared/static/date-functions';
import { ColumnComponent } from '@progress/kendo-angular-excel-export';
import { DQOIMessage } from '../../shared/models/DQOIMessage';
import { MessageType } from '../../shared/enums/MessageType';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { GridEditModes } from '@app/cp/shared/static/CommonValues';
import { SaveMode } from '../../shared/enums/SaveMode';

@Component({
  selector: 'workorder-notes',
  templateUrl: './workorder-notes.component.html',
    styleUrls: ['./workorder-notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkOrderNotesComponent extends BaseGridEditFormLinesComponent<v_DispatchNoteBus, null, DispatchesService> implements OnInit, OnDestroy {
    @Input() IsInjury: boolean = false;
    @Input() canEditOthersNotes: boolean = false;
    @Input() displayRows: number;
    @Input() gridInputHeight: number = null;
    @Input() gridTitle: string = 'Notes';
    @Output() dqoiMessage: EventEmitter<DQOIMessage> = new EventEmitter<DQOIMessage>();

    isTechnician: boolean = false;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private currentSubscription: Subscription;
    private destroy$ = new Subject();

    get rowstoDisplay(): number {
        if (this.displayRows) { return this.displayRows; }
        return this.pageSizeNoPaging;
    }
    subs_dataRef: Subscription;
    subs_dataRefUpdated: Subscription;

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, private zone: NgZone, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_DispatchNoteBus";
        this.appCode = "DispatchNotes";
        this.appName = "Dispatch Notes";

        this.callSaveIndividualInsteadOfSave = true;

        //necessary for grid displays that dont search
        this.disableCpSearchDialog();
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            if (!data) {
                return;
            }
            this.isTechnician = data?.isTechnician(this.globals.personId);
        });

    }
    canEditRow(dataItem: v_DispatchNoteBus, column: ColumnComponent) {
        let canEdit = super.canEditRow(dataItem);
        if (column.field == "visibleToCustomer") { canEdit = false; }
        return canEdit;
    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchNotesId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'dispatchNotes': new UntypedFormControl(),
            'visibleToCustomer': new UntypedFormControl(),
            'highlight': new UntypedFormControl(),
            'isWarning': new UntypedFormControl(),
            'techNote': new UntypedFormControl(),
            'dispatchNotesPersonId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updatedt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'hideLogBook': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
        });
    }
    setForm() {
        this.setFromReferenceData(this.selectedData)
        this.editForm.patchValue({
            dispatchNotesId: this.selectedData.dispatchNotesId,
            dispatchId: this.selectedData.dispatchId,
            dispatchNotes: this.selectedData.dispatchNotes,
            visibleToCustomer: this.selectedData.visibleToCustomer,
            highlight: this.selectedData.highlight,
            isWarning: this.selectedData.isWarning,
            techNote: this.selectedData.techNote,
            dispatchNotesPersonId: this.selectedData.dispatchNotesPersonId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updatedt: this.selectedData.updatedt,
            updateUserId: this.selectedData.updateUserId,
            hideLogBook: this.selectedData.hideLogBook,
            personName: this.selectedData.personName
        });
        this.notes = CommonFunctions.getStringValueIfNull(this.selectedData.dispatchNotes);
    }
    setFromReferenceData(data: v_DispatchNoteBus) {
        data.personName = this.personName(data.dispatchNotesPersonId);
        return data;
    }
    setFromNonFormData(data: v_DispatchNoteBus) {
        data.dispatchNotes = this.notes;
        console.log("setFromNonFormData-data", data, this.notes);
        return data;
    }
    notesPersonId(dataItem: v_DispatchNoteBus = null): any {
        dataItem = !dataItem ? this.selectedData : dataItem;
        return dataItem ? dataItem.dispatchNotesPersonId : null;
    }
    public cancelHandler(): void {
        if (this.formActive) { return }
        if (this.gridDataDuringEdit) { this.gridData = _.cloneDeep(this.gridDataDuringEdit); }
        this.closeEditor();
    }

    protected override closeEditor(): void {
        if (this.formActive) { return };
        this.isNew = false;
        this.editForm = undefined;
        this.showCpSearchDialog = false;
        if (this.grid && this.grid.pageSize && this.hasGridData) {
            this.grid.data = {
                data: this.gridData.slice(this.grid.skip, this.grid.skip + this.grid.pageSize),
                total: this.gridData.length
            };
        }
        if (this.saveMode == SaveMode.all) {
            this.sendParentMessage(MessageType.changed);
        }
    }
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].personName) {
                    this.gridData[i].personName = this.personName(this.gridData[i].dispatchNotesPersonId);
                }
            }
        }
       this.getDragReady();
    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }

    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.workOrderNotesGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(takeUntil(this.destroy$)).pipe(
                tap(({ dataTransfer }) => {
                    try {

                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];

            }));



            sub.add(dragEnd.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 4;
                event.dropid = event.dispatchNotesId

                this.dropEvent.emit(event);

            }));
        });

        return sub;
    }

    protected getChangedObject(dataObj: v_DispatchNoteBus) {
        let busObj: DispatchNoteBus = new DispatchNoteBus(dataObj);
        busObj.dispatchNotes1 = dataObj.dispatchNotes;
        busObj.setBeforeSave();
        if (this.IsInjury) {
            busObj.isWarning = true;
        }
        return busObj;
    }
    saveIndividual(dataObj: v_DispatchNoteBus): Promise<BaseMessageInfo> {
        let busObj: DispatchNoteBus = this.getChangedObject(dataObj);
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveNote(busObj).toPromise().then((data: DispatchNoteBus) => {
                console.log("note-save-ind-as-a: ", data);
                if (data != null) {
                    let newDataObj: v_DispatchNoteBus = new v_DispatchNoteBus();
                    console.log("note-save-ind-as-b: ", newDataObj, data);
                    newDataObj.setFromBusobj(data);
                    if (data.insertDt == data.updatedt) {
                        newDataObj.insertDt = DateFunctions.getDateNow();
                        newDataObj.updatedt = newDataObj.insertDt; }
                    else {
                        newDataObj.updatedt = DateFunctions.getDateNow();

                    }
                    newDataObj.dispatchNotes = data.dispatchNotes1;
                    newDataObj = this.setFromReferenceData(newDataObj);
                    retInfo.primaryReturn = newDataObj;
                    if (newDataObj.hasId) {
                        this.notify(this.appCode + " Saved Successfully!");
                        let dMmessage: DQOIMessage = new DQOIMessage();

                        dMmessage.messageData = this.parentId;
                        dMmessage.messageType = MessageType.childSaved;
                        this.dqoiMessage.emit(dMmessage);
                    } else {
                        retInfo.message = "Duplicate Note";
                        retInfo.saveError = true;
                    }

                }
                else {
                    retInfo.message = "Error Saving"
                    retInfo.saveError = true;
                    this.saveError(null, retInfo.message);
                }
                this.dataLoading = false;
                if (this.GridEditMode === GridEditModes.editButton) {
                    this.doParentAction(this.parentId, "GETPAGEDATA", "DISPATCHNOTES");
                }
                resolve(retInfo);
            });
        });
    }

    deleteIndividual(data: v_DispatchNoteBus) {
        if (data.hasId) {
            this.svc_data.deleteNote(data.dispatchNotesId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    let delDataObj: v_DispatchNoteBus = new v_DispatchNoteBus(data);
                    this.deleteSuccess(delDataObj);
                    this.removeLocal(delDataObj);
                    this.cd.detectChanges();
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }

    instantSaveCBChanged(e: any, dataItem: v_DispatchNoteBus, rowIndex, column, columnIndex, setEditMode: boolean = true) {
        if (column.field == "visibleToCustomer") {
            dataItem.visibleToCustomer = e.target.checked;
            this.saveIndividual(dataItem);
        }
    }

    trySave() {
        if (CommonFunctions.hasStringValue(this.notes)) {
            this.saveForm();
        }
        else {
            this.globals.notifyWarning("You Must Enter the Required Note");
        }
    }

    saveForm() {
        this.saveCurrent();
        this.hideForm();
        if (this._addOnly) {
            let info: BaseMessageInfo = new BaseMessageInfo();
            info.primaryReturn = this.dataAddOnly;
            this.closeWithInfo(info);
            this.dataAddOnly = null;
        }
        else {
            this.close(true);
        }
    }
    dataAddOnly: DispatchNoteBus;
    protected customSaveLocal(data: v_DispatchNoteBus) {
        this.dataAddOnly = this.getChangedObject(data);
    }

}

